import { post } from '../../services/request';
import { CalculatorInput, CalculationResult, RULES_VERSION } from './calculator';

export interface SaveCalculationPayload {
  schemaVersion: '1.0';
  rulesVersion: string;
  requestId: string;
  kind: 'calculation';
  createdAt: string;
  input: CalculatorInput;
  contact: {
    propertyCode: string;
    broker: string;
    tenant: string;
    cpf: string;
  };
  clientCalculation: CalculationResult;
}

export interface SaveCalculationResponse {
  persisted: boolean;
  id: string;
  requestId: string;
  status: string;
  savedAt: string;
  calculation: CalculationResult;
  spreadsheetStatus?: string;
}

export const saveCreditoRealCalculation = (
  input: CalculatorInput,
  calculation: CalculationResult,
  contact: SaveCalculationPayload['contact']
) => {
  const requestId = `CR-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  const payload: SaveCalculationPayload = {
    schemaVersion: '1.0',
    rulesVersion: RULES_VERSION,
    requestId,
    kind: 'calculation',
    createdAt: new Date().toISOString(),
    input,
    contact,
    clientCalculation: calculation
  };
  return post('/public/credito-real/fire-insurance/calculations', payload, {
    'Idempotency-Key': requestId
  }) as Promise<SaveCalculationResponse>;
};
